import { Box } from "@mui/material";
import { NodeViewWrapper } from "@tiptap/react";
import type { NodeViewProps } from "@tiptap/react";
import { useTheme } from "@mui/material";

/**
 * In-editor rendering of a variable chip.
 * Uses theme tokens for display. The renderHTML method on the extension
 * uses hardcoded colors for email client compatibility.
 */
export const VariableChipNodeView = ({ node }: NodeViewProps): JSX.Element => {
  const theme = useTheme();
  const label = (node.attrs.label as string) || "";

  return (
    <NodeViewWrapper as="span" style={{ display: "inline" }}>
      <Box
        component="span"
        contentEditable={false}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          height: "24px",
          gap: "8px",
          border: `1px solid ${theme.palette.primary.tint}`,
          borderRadius: "4px",
          padding: "2px 6px",
          backgroundColor: theme.palette.primary.tint,
          cursor: "default",
          whiteSpace: "nowrap",
          margin: "0 2px",
          verticalAlign: "baseline",
          userSelect: "none",
        }}
      >
        <Box
          component="span"
          sx={{
            ...theme.typography["body-small"],
            color: theme.palette.primary.main,
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          {label}
        </Box>
      </Box>
    </NodeViewWrapper>
  );
};
